// extracted by mini-css-extract-plugin
export default {"wrapper":"BuildSnapshotThumbChangeOverlay__wrapper__d36t3"};